import { RegisteredComponent } from "@builder.io/sdk-react";

export const contentReplicatorBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Content Replicator Block",
  image: "https://icons.veryicon.com/png/o/miscellaneous/unicons/repeat-13.png",
  friendlyName: "Content Replicator",
  description:
    "Replicates (clones) content from other elements on the page using CSS selectors",
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  canHaveChildren: false,
  inputs: [
    {
      name: "classSelectors",
      type: "string",
      required: true,
      friendlyName: "Class Selectors",
      helperText:
        'CSS class selectors to find source elements (comma-separated). Example: ".tab-1, .tab-2, .event-list"',
      defaultValue: "",
      localized: false,
    },
  ],
  noWrap: true,
  defaults: {
    responsiveStyles: {
      large: {
        width: "100%",
      },
    },
  },
};
